import CursorGlow from "@/components/landing/CursorGlow";

const BLOCKS = [
  {
    id: "precision",
    badge: "01",
    title: "Uncompromising Precision",
    copy: "Every campaign is treated as an integrated software deployment. No guesswork, no vanity metrics — just engineered outcomes and audit-grade reporting.",
  },
  {
    id: "execution",
    badge: "02",
    title: "Flawless 360° Execution",
    copy: "From digital code to physical paper weight, we manage the entire ecosystem so your internal team can scale without the operational drag of vendor management.",
  },
  {
    id: "resonance",
    badge: "03",
    title: "Hyper-Local Market Resonance",
    copy: "Translating complex corporate value into sharp cultural narratives that convert deeply across Tier-2 and Tier-3 markets — language, lensing, and layout fluent.",
  },
];

export default function Methodology() {
  return (
    <section
      id="methodology"
      data-testid="methodology-section"
      className="relative py-28 sm:py-36 bg-white border-t border-black/5 overflow-hidden"
    >
      <CursorGlow size={700} />
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          {/* Sticky left */}
          <div
            data-testid="methodology-sticky"
            className="lg:col-span-5 lg:sticky lg:top-32 lg:self-start"
          >
            <span className="inline-block text-xs uppercase tracking-[0.3em] font-semibold text-[#2770FD] mb-5">
              The Methodology
            </span>
            <h2
              data-testid="methodology-heading"
              className="font-display text-black text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
            >
              Engineered for{" "}
              <span className="text-accent-blue">Measurable Growth.</span>
            </h2>
            <p className="mt-6 text-black/70 text-base sm:text-lg font-light leading-relaxed max-w-md">
              Our system isn&apos;t a creative brief. It&apos;s a deployment doctrine —
              with checkpoints, accountability, and a relentless bias toward
              compounding business outcomes.
            </p>

            <div className="mt-10 flex items-center gap-3">
              <div className="h-px w-12 bg-[#2770FD]" />
              <span className="text-xs uppercase tracking-[0.3em] text-black/60">
                Three Operating Principles
              </span>
            </div>
          </div>

          {/* Right typography lines */}
          <div className="lg:col-span-7 flex flex-col">
            {BLOCKS.map((b, idx) => (
              <div
                key={b.id}
                data-testid={`methodology-block-${b.id}`}
                className={`group grid grid-cols-12 gap-6 py-10 ${
                  idx !== BLOCKS.length - 1 ? "border-b border-black/15" : ""
                }`}
              >
                <div className="col-span-2 sm:col-span-1">
                  <span className="font-display text-[#2770FD] text-3xl sm:text-4xl tracking-[0.15em]">
                    {b.badge}
                  </span>
                </div>
                <div className="col-span-10 sm:col-span-11">
                  <h3 className="font-display text-black text-3xl sm:text-4xl leading-[1.05] tracking-tight">
                    {b.title}
                  </h3>
                  <p className="mt-4 text-black/70 text-sm sm:text-base font-light leading-relaxed max-w-2xl">
                    {b.copy}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
